<template>
  <div class="app-container">
    <header class="header">
      <h1><i class="fas fa-gopuram"></i> 材分八等 · 构木成文</h1>
      <div class="header-sub">中国古代建筑成就数字展 · 民居/官府/皇宫/桥梁 (1911前)</div>
    </header>
    <NavBar />
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script setup>
import NavBar from './components/NavBar.vue'
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: 'Microsoft YaHei', '华文楷体', 'KaiTi', sans-serif;
  background-color: #1e1a16;
  color: #ede0d0;
  height: 100vh;
  overflow: hidden;
}
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.header {
  background: rgba(40, 30, 20, 0.95);
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #b58b5b;
  flex-shrink: 0;
}
.header h1 {
  font-size: 1.8rem;
  font-weight: 400;
  letter-spacing: 4px;
  color: #eace9f;
}
.header h1 i {
  color: #c49a6c;
  margin-right: 10px;
}
.header-sub {
  font-size: 1rem;
  color: #bda78b;
  border-left: 1px solid #6a4e2e;
  padding-left: 20px;
}
.main-content {
  flex: 1;
  overflow-y: auto;
  background: #1f1a15;
  padding: 20px 30px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
